"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* -------------------------------------------------------------------------

	PUNITED.top

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */

// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.top) PUNITED.top = {};
(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.top;

  /* -----------------------------------------------------
  	----------------------------------------------------- */
  ns.main = function () {
    var slideSpeed = 2000;
    var slideDelay = 3000;
    var splide = new Splide('.splide', {
      type: 'fade',
      rewind: true,
      speed: slideSpeed,
      easing: 'ease',
      autoplay: true,
      interval: slideSpeed + slideDelay,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      arrows: false,
      pagination: false,
      heightRatio: 900 / 1440,
      breakpoints: {
        680: {
          heightRatio: 635 / 375
        }
      }
    });
    splide.mount();
    var _splide$Components = splide.Components,
      Autoplay = _splide$Components.Autoplay,
      Slides = _splide$Components.Slides;
    Autoplay.pause();
    splide.on('move', function (newIndex, prevIndex, destIndex) {
      var slide = Slides.getAt(prevIndex).slide;
      var $slide = $(slide);
      $slide.ripples({
        resolution: 136,
        dropRadius: 10,
        perturbance: 0.04,
        interactive: false
      });
      var radius = slide.offsetWidth * 13.88 / 100;
      var x = radius + Math.random() * (slide.offsetWidth - radius * 2);
      var y = radius + Math.random() * (slide.offsetHeight - radius * 2);
      $slide.ripples('drop', x, y, radius, 1);
      setTimeout(function () {
        $slide.ripples('destroy');
      }, slideSpeed);
    });
    var intro = document.querySelector('.intro');
    var movie = document.querySelector('.top_main__movie_video');
    if (!intro) {
      Autoplay.play();
      reveal();
      return;
    }
    var introInner = intro.querySelector('.intro__inner');
    var logo = intro.querySelector('.intro__logo');
    var logoCap = logo.querySelector('svg:first-child');
    var logoDots = logo.querySelectorAll('svg:not(:first-child)');
    gsap.set(logoCap, {
      opacity: 0,
      rotate: 30,
      transformOrigin: 'center 16px'
    });
    var text = intro.querySelector('.intro__text');
    var textChars = text.querySelectorAll('svg');
    var textMidIndex = Math.round(textChars.length / 2);
    textMidIndex -= textMidIndex % 2 === 1 ? 0.5 : 0;
    textChars.forEach(function (_char, i) {
      var delta = i - textMidIndex;
      var sign = Math.sign(delta);
      var multiplier = Math.abs(delta);
      var x = 20 * multiplier * sign;
      gsap.set(_char, {
        opacity: 0,
        x: x
      });
    });
    gsap.set(introInner, {
      opacity: 1
    });
    var outTl = gsap.timeline({
      paused: true,
      // delay: 0.5,
      onStart: function onStart() {
        Autoplay.play();
      },
      onComplete: function onComplete() {
        reveal();
      }
    }).to([logo, text], {
      opacity: 0,
      stagger: {
        each: 0.1
        // ease: 'power3.in'
      }
    }).to(intro, {
      opacity: 0,
      duration: 1,
      ease: 'power1.out'
    });
    var introInPlayed = false;
    var firstImgLoaded = false;
    var dotsRotation = function dotsRotation() {
      var tl = gsap.timeline();
      gsap.set(logo, {
        rotateZ: 90,
        rotateY: -90
      });
      tl.to(logo, {
        rotateZ: 0,
        rotateY: 0,
        // opacity: 1,
        duration: 1,
        ease: 'power1.out'
      });
      return tl;
    };
    var commonDotProps = {
      duration: 1,
      ease: 'back.out(0.75)'
    };
    var dot1 = function dot1() {
      var tl = gsap.timeline();
      tl.from(logoDots[0], _objectSpread({
        y: 175
      }, commonDotProps));
      return tl;
    };
    var dot2 = function dot2() {
      var tl = gsap.timeline();
      tl.from(logoDots[1], _objectSpread({
        x: 175,
        y: 175
      }, commonDotProps));
      return tl;
    };
    var dot3 = function dot3() {
      var tl = gsap.timeline();
      tl.from(logoDots[2], _objectSpread({
        x: -175,
        y: 175
      }, commonDotProps));
      return tl;
    };
    var dot4 = function dot4() {
      var tl = gsap.timeline();
      tl.from(logoDots[3], _objectSpread({
        x: 175,
        y: -175
      }, commonDotProps));
      return tl;
    };
    var dot5 = function dot5() {
      var tl = gsap.timeline();
      tl.from(logoDots[4], _objectSpread({
        x: 200
      }, commonDotProps));
      return tl;
    };
    var dot6 = function dot6() {
      var tl = gsap.timeline();
      tl.from(logoDots[5], _objectSpread({
        x: -75,
        y: 100
      }, commonDotProps));
      return tl;
    };
    var dot7 = function dot7() {
      var tl = gsap.timeline();
      tl.from(logoDots[6], _objectSpread({
        x: -175,
        y: -175
      }, commonDotProps));
      return tl;
    };
    var dot8 = function dot8() {
      var tl = gsap.timeline();
      tl.from(logoDots[7], _objectSpread({
        x: -175,
        y: -150
      }, commonDotProps));
      return tl;
    };
    var logoTl = gsap.timeline({
      paused: true,
      delay: 0.5,
      onComplete: function onComplete() {
        if (firstImgLoaded) {
          outTl.play();
        }
        introInPlayed = true;
      }
    }).add(dotsRotation()).add(dot1(), '<').add(dot2(), '<').add(dot3(), '<').add(dot4(), '<').add(dot5(), '<').add(dot6(), '<').add(dot7(), '<').add(dot8(), '<').to(logoCap, {
      opacity: 1,
      rotate: 0,
      duration: 0.5,
      ease: 'power3.out'
    }, '>-0.1').to(textChars, {
      opacity: 1,
      x: 0,
      stagger: {
        amount: 0.1,
        from: 'center',
        ease: 'power4.in'
      },
      duration: 1,
      ease: 'power4.out'
    }, '>-0.2');
    var key = "introPlayedAt";
    var duration = 1000 * 60 * 60 * 24;
    var lastPlayedAt = parseInt(window.localStorage.getItem(key), 10) || 0;
    var now = Date.now();
    if (lastPlayedAt + duration < now) {
      window.localStorage.setItem(key, "".concat(Date.now()));
      logoTl.play();
      var firstSlide = Slides.getAt(splide.index).slide;
      var firstImg = new Image();
      firstImg.addEventListener('load', function () {
        if (introInPlayed) {
          outTl.play();
        }
        firstImgLoaded = true;
      });
      var bgImgProp = getComputedStyle(firstSlide).getPropertyValue('background-image');
      var match = /url\("(.*)"\)/.exec(bgImgProp);
      firstImg.src = match[1];
    } else {
      Autoplay.play();
      reveal();
    }
    function reveal() {
      movie === null || movie === void 0 || movie.play();
      gsap.set(intro, {
        display: 'none'
      });
    }
  };
  ns.movieModal = function () {
    var modal = document.querySelector('.top_movie_modal');
    if (!modal) {
      return;
    }
    var trigger = document.querySelector('.top_main__movie_video_wrapper');
    var smallVideo = trigger.querySelector('.top_main__movie_video');
    var largeVideo = modal.querySelector('.top_movie__video');
    PUNITED.utils.modal(modal, [trigger], {
      onOpenStart: function onOpenStart() {
        largeVideo.currentTime = 0;
        largeVideo.play();
      },
      onOpenEnd: function onOpenEnd() {
        smallVideo.pause();
      },
      onCloseStart: function onCloseStart() {
        smallVideo.play();
      },
      onCloseEnd: function onCloseEnd() {
        largeVideo.pause();
      }
    });
  };
})();
$(function () {
  PUNITED.top.main();
  PUNITED.top.movieModal();
  PUNITED.utils.modal(document.getElementById('recruit_site_modal'), [document.getElementById('recruit_site_modal_trigger')]);
});